import { SkeletonUI } from '@_shared/ui';
import * as S from './ContentListItem.style';

export function SkeletonContentListItem() {
	return (
		<S.Container isEditMode={false}>
			<S.TextContainer>
				<SkeletonUI width="60px" height="20px" borderRadius="8px" />
				<SkeletonUI width="200px" height="42px" borderRadius="8px" />
				<SkeletonUI width="120px" height="20px" borderRadius="8px" />
			</S.TextContainer>

			<div style={{ flexShrink: 0 }}>
				<SkeletonUI width="64px" height="64px" borderRadius="8px" />
			</div>
		</S.Container>
	);
}
